import React from "react";
import { Navigate } from "react-router-dom";

const AdminRoute = ({ children }) => {
  const isAdmin = localStorage.getItem("isAdmin") === "true"; // Kiểm tra xem người dùng có phải là admin không

  return isAdmin ? children : <Navigate to="/" />; // Nếu là admin, cho phép truy cập; nếu không, chuyển hướng về trang chính
};

export default AdminRoute; 